<template>
  <div ref="treeSide" class="app-tree-side" :class="isOpen ? '' : 'side-close'">
    <div class="tree-side-toggle-btn" @click="toggleTreeAside"></div>
    <div ref="treeSideToggleLine" class="tree-side-toggle-line"></div>
    <slot></slot>
    <div ref="treeSideEmpty"></div>
  </div>
</template>

<script type="text/ecmascript-6">
import AppTreeSide from './AppTreeSide.js'
export default AppTreeSide
</script>

<style lang="scss">
@import "AppTreeSide.scss";
</style>



// WEBPACK FOOTER //
// src/components/appTreeSide/AppTreeSide.vue